import React from "react";
import styled from "styled-components";
import {Field} from "formik";
import {InputsContainer} from "./radioStyles";
import CounterInputFormik from "./CounterInputFormik";

const TypeOfAdvancementInput = ({values}) => {

    const advancementTypeChoices = [
        {
            id: 'percentage',
            name: 'Pourcentage',
            className: 'selected',
        },
        {
            id: 'step',
            name: 'Quantité',
            className: '',
        }]


    return (
        <ContainerGrid>
            <FirstSection>
                <label> Objectif chiffré : </label>
                <WrapperBoxes>
                    {advancementTypeChoices.map(a => (
                        <div key={a.id}>
                            <InputsContainer>
                                <label>
                                    <Field
                                        name="advancementType"
                                        type={"radio"}
                                        value={a.id}
                                    />
                                    <div><p> {a.name}  </p></div>
                                </label>
                            </InputsContainer>

                        </div>))}
                </WrapperBoxes>
            </FirstSection>

            <ContainerInputNumber>
                <FlexCol>
                    <label> Avancement : </label>
                    <CounterInputFormik
                        name={'advancement'}
                        step={1}/>
                </FlexCol>
                <FlexCol>
                    <label>
                        {values.advancementType === "percentage" ? "Pourcentage" : "Quantité"} à atteindre :
                    </label>
                    <CounterInputFormik
                        name={'target'}
                        step={1}/>
                </FlexCol>
            </ContainerInputNumber>
        </ContainerGrid>
    )
}


const WrapperBoxes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1rem;
`


const ContainerGrid = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5em;
  border-radius: 10px;
  gap: 1em;


  section:first-child {
    margin-top: 1em;
    align-self: center;;
  }
`

const FirstSection = styled.div`
  display: flex;
  align-items: center;

  label {
    white-space: nowrap;
  }`

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding: 0.5em;
  gap: 0.5em;
  width: 50%;

  div {
    align-self: center;
  }

  label {
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    white-space: nowrap;

  }
`

const ContainerInputNumber = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`
export default TypeOfAdvancementInput